module.exports = "<div class=\"preload\">\n  <div class=\"circle\"></div>\n  <span>{{message}}</span>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /vercel/workpath0/src/app/components/loading/loading.component.html
// module id = ../../../../../src/app/components/loading/loading.component.html
// module chunks = main